import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const updates = [
  {
    date: "Czerwiec 2026",
    title: "Nowe funkcje analityczne",
    desc: "Wprowadziliśmy zaawansowane narzędzia do wizualizacji danych, w tym interaktywne wykresy i dashboardy.",
  },
  {
    date: "Maj 2026",
    title: "Integracja z Google Workspace",
    desc: "USFansSpreadsheet teraz w pełni integruje się z Google Workspace, umożliwiając płynną współpracę.",
  },
  {
    date: "Kwiecień 2026",
    title: "Ulepszone bezpieczeństwo",
    desc: "Wdrożyliśmy dwuskładnikowe uwierzytelnianie i zaawansowane szyfrowanie end-to-end.",
  },
  {
    date: "Marzec 2026",
    title: "Nowy interfejs użytkownika",
    desc: "Przeprojektowaliśmy interfejs, aby był jeszcze bardziej intuicyjny i przyjazny dla użytkownika.",
  },
];

export default function UpdatesSection() {
  const { t } = useTranslation("home");

  return (
    <section className="bg-background-50 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 text-center mb-4">
          {t("updatesTitle")}
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12">
          Bądź na bieżąco z najnowszymi aktualizacjami USFansSpreadsheet
        </p>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2"></div>

          <div className="space-y-8">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                  i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                }`}
              >
                <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full bg-accent-500 -translate-x-1/2 mt-1.5 z-10"></div>

                <div className={`ml-10 md:ml-0 md:w-1/2 ${i % 2 === 0 ? "md:pr-12 md:text-right" : "md:pl-12"}`}>
                  <span className="text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full">
                    {item.date}
                  </span>
                  <h3 className="mt-2 text-base font-semibold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>

                <div className="hidden md:block md:w-1/2"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artykul/usfansspreadsheet-aktualizacje-2026"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t("learnMore", { ns: "common" })}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}